import { ALL_CATEGORY, FeedArticle, FeedCategory } from '@pff-consumer/schema'
import { useSelector, useDispatch } from 'react-redux'
import { feedSelectors, feedSlice } from './feed.slice'

export const feedHooks = {
  useFeedCategories: () => useSelector(feedSelectors.getFeedCategories),
  useFeedArticles: (feedCategorySlug: FeedCategory['slug']) =>
    feedCategorySlug === ALL_CATEGORY.slug
      ? useSelector(feedSelectors.getFeedArticles)
      : useSelector(feedSelectors.getFeedArticlesByFeedCategory(feedCategorySlug)),
  useArticles: () => useSelector(feedSelectors.getArticles),
  useFeedArticleById: (articleId: FeedArticle['id']) => useSelector(feedSelectors.getFeedArticleById(articleId)),
  useBookmarkArticles: () => useSelector(feedSelectors.getBookmarkFeedArticles),
  useBookmarkArticleIds: () => useSelector(feedSelectors.getBookmarkArticleIds),
  useUnreadArticlesList: () => useSelector(feedSelectors.getUnreadArticlesList),
  useFilterCategory: () => useSelector(feedSelectors.getFilterCategory),
  useArticleActions: () => {
    const dispatch = useDispatch()
    return {
      addBookmarkedArticleId: (payload: { id: number }) => {
        dispatch(feedSlice.actions.addBookmarkedArticleId(payload))
      },
      addBookmarkedArticles: (payload: { bookmarkedArticles: FeedArticle[] }) => {
        dispatch(feedSlice.actions.addBookmarkedArticles(payload))
      },
      removeBookmarkedArticle: (payload: { id: number }) => {
        dispatch(feedSlice.actions.removeBookmarkedArticle(payload))
      },
      updateUnreadArticlesList: () => {
        dispatch(feedSlice.actions.updateUnreadArticlesList())
      },
      addFilterCategory: (payload: { displayName: string; order: number; slug: string }) => {
        dispatch(feedSlice.actions.addFilterCategory(payload))
      },
    }
  },
}
